import { quickEntries } from '@/mocks/home';
import { useToast } from '@/components/base/Toast';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function QuickEntrySection() {
  const showToast = useToast();

  return (
    <section id="quick" className="scroll-mt-24 border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            index="01"
            eyebrow="快捷导航"
            title="六种入口方式，总有一条适合你"
            desc="从官网主域到备用线路、移动端与客户端，常用的访问方式都已归拢在这里，点开即可查看对应入口。"
          />
          <p className="shrink-0 text-xs text-foreground-500 lg:pb-2">共收录 {quickEntries.length} 类入口方式</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {quickEntries.map((item, i) => (
            <button
              key={item.id}
              type="button"
              onClick={() => showToast(`「${item.title}」入口正在为你准备`)}
              data-reveal
              style={{ transitionDelay: `${i * 60}ms` }}
              className="group flex cursor-pointer flex-col items-start rounded-lg border border-background-200 bg-background-50 p-5 text-left transition-colors hover:border-primary-400 md:p-6"
            >
              <div className="flex w-full items-start justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-foreground-950">
                  <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <span className="rounded-full border border-accent-200 bg-accent-50 px-2.5 py-1 text-[11px] font-semibold text-accent-700">
                  {item.tag}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{item.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-accent-700">
                进入入口
                <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}